import { clearTeamManagementViewCache } from '../utils/teamManagementViewCache';
import { clearTeamManagementCountsWarmCache } from '../utils/teamManagementCountsWarmCache';
import { clearWidgetSettingsWarmCache } from '../utils/widgetSettingsWarmCache';
import { clearActiveChatListWarmCache } from '../utils/activeChatListWarmCache';

export const authMiddleware = (store) => (next) => (action) => {
  if (action?.meta?.arg?.authToken === undefined) {
    const state = store.getState();
    const token = state.loginToken?.token;
    if (token) {
      action.meta.arg.authToken = token;
    }
  }

  if (action.type === 'loginUser/resetUser') {
    clearTeamManagementViewCache();
    clearTeamManagementCountsWarmCache();
    clearWidgetSettingsWarmCache();
    clearActiveChatListWarmCache();
  }

  return next(action);
};